import { render, staticRenderFns } from "./judgement.vue?vue&type=template&id=466c99df&scoped=true&"
import script from "./judgement.vue?vue&type=script&lang=js&"
export * from "./judgement.vue?vue&type=script&lang=js&"
import style0 from "./judgement.vue?vue&type=style&index=0&id=466c99df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466c99df",
  null
  
)

export default component.exports